import { useRef, useEffect } from 'react'
import Button from '../Button.jsx'
import Field from '../form/Field.jsx'
import Hidden from '../form/Hidden.jsx'
import { ThirdPartyApiList } from '../../repo/ThirdPartyApiRepo'

export default function AdminMatchesForm({match, teams, tournament, errors, isSubmitting}) {
  const idRef = useRef()
  const teamAIdRef = useRef()
  const teamBIdRef = useRef()
  const tournamentIdRef = useRef()
  const startsAtRef = useRef()
  const groupNameRef = useRef()
  const phaseRef = useRef()
  const thirdPartyLabelRef = useRef()
  const thirdPartyIdRef = useRef()

  useEffect(() => {
    tournamentIdRef.current.value = tournament.id

    if (match) {
      idRef.current.value = match.id;
      teamAIdRef.current.value = match.team_a_id;
      teamBIdRef.current.value = match.team_b_id;
      startsAtRef.current.value = match.starts_at;
      groupNameRef.current.value = match.group_name;
      phaseRef.current.value = match.phase;
      thirdPartyLabelRef.current.value = match.third_party_label;
      thirdPartyIdRef.current.value = match.third_party_id;
    } else {
      teamAIdRef.current.value = '';
      teamBIdRef.current.value = '';
    }
  }, [match, tournament]);


  function teamAOnSelect(selectedOption) {
    teamAIdRef.current.setValue(selectedOption.id)
  }

  function teamBOnSelect(selectedOption) {
    teamBIdRef.current.setValue(selectedOption.id)
  }

  function teamAIdHasError() {
    if (errors && errors.team_a_id) {
      return "Equipe inválida"
    }

    return ""
  }

  function teamBIdHasError() {
    if (errors && errors.team_b_id) {
      return "Equipe inválida"
    }

    return ""
  }

  function startsAtHasError() {
    if (errors && errors.starts_at) {
      return "Data de início inválida"
    }

    return ""
  }

  return(
    <>
      <Field
        type={"auto_complete"}
        ref={teamAIdRef}
        name={"team_a_id"}
        id={"team_a_id"}
        label={"Equipe A"}
        required={""}
        defaultValue={match && match.team_a_id ? {id: match.team_a_id, name: match.team_a_name} : null}
        error={teamAIdHasError()}
        disabled={isSubmitting}
        onSelectOption={teamAOnSelect}
      />

      <Field
        type={"auto_complete"}
        ref={teamBIdRef}
        name={"team_b_id"}
        id={"team_b_id"}
        label={"Equipe B"}
        required={""}
        defaultValue={match && match.team_b_id ? {id: match.team_b_id, name: match.team_b_name} : null}
        error={teamBIdHasError()}
        disabled={isSubmitting}
        onSelectOption={teamBOnSelect}
      />

      <Field type={"input"} ref={startsAtRef} name={"starts_at"} id={"starts_at"} label={"Início em"} required={""} disabled={isSubmitting} error={startsAtHasError()}/>

      <Field type={"input"} ref={groupNameRef} name={"group_name"} id={"group_name"} label={"Grupo"} required={""} disabled={isSubmitting}/>

      <Field type={"input"} ref={phaseRef} name={"phase"} id={"phase"} label={"Fase"} required={""} disabled={isSubmitting}/>

      <Field
        type={"select"}
        name={"third_party_label"}
        id={"third_party_label"}
        label={"API de Terceiros"}
        required={""}
        options={ThirdPartyApiList()}
        defaultValue={''}
        disabled={isSubmitting}
        ref={thirdPartyLabelRef}/>

      <Field
        type={"input"}
        name={"third_party_id"}
        id={"third_party_id"}
        label={"ID de Terceiros"}
        required={""}
        disabled={isSubmitting}
        ref={thirdPartyIdRef}/>

      <div className="flex items-center gap-2 mt-2 mb-4">
        <input type="checkbox" defaultChecked={match?.is_demo} name="is_demo" id="is_demo" />
        <label htmlFor="is_demo" className="text-sm cursor-pointer">Partida de demonstração?</label>
      </div>

      <Hidden ref={tournamentIdRef} name={"tournament_id"} id={"tournament_id"} />

      {match && match.id && (
        <Hidden ref={idRef} name={"id"} id={"id"} />
      )}

      <Button styleName="blue" disabled={isSubmitting} >
        {isSubmitting ? 'Saving...' : 'Save'}
      </Button>
    </>
  )
}
